<template>
  <a-form-item
    name="competenceSubject"
    :help="errors.getError('competenceSubject')"
    :validate-status="errors.getStatus('competenceSubject')"
  >
    <label class="field__label"> Предметная область </label>
    <c-input-competence
      :type="COMPETENCE_TYPE_SUBJECT"
      :competence="model.competenceSubject"
      :competence-status="model.status"
      :competence-options="competenceOptions"
      :disabled="disabled"
      @update="handleUpdate"
      @delete="handleDelete"
    />
  </a-form-item>

  <a-form-item
    name="competenceTechnology"
    :help="errors.getError('competenceTechnology')"
    :validate-status="errors.getStatus('competenceTechnology')"
  >
    <label class="field__label"> Технологии </label>
    <c-input-competence
      :type="COMPETENCE_TYPE_TECHNOLOGY"
      :competence="model.competenceTechnology"
      :competence-status="model.status"
      :competence-options="competenceOptions"
      :disabled="disabled"
      @update="handleUpdate"
      @delete="handleDelete"
    />
  </a-form-item>

  <a-form-item
    name="competenceSkill"
    :help="errors.getError('competenceSkill')"
    :validate-status="errors.getStatus('competenceSkill')"
  >
    <label class="field__label"> Навыки </label>
    <c-input-competence
      :type="COMPETENCE_TYPE_SKILL"
      :competence="model.competenceSkill"
      :competence-status="model.status"
      :competence-options="competenceOptions"
      :disabled="disabled"
      @update="handleUpdate"
      @delete="handleDelete"
    />
  </a-form-item>
</template>

<script setup>
  import { onMounted, reactive, watch } from 'vue';
  import ErrorsHandler from '@/components/form/errors-handler';
  import CInputCompetence from '@/components/UI/CInputCompetence.vue';
  import {
    COMPETENCE_TYPE_SKILL,
    COMPETENCE_TYPE_SUBJECT,
    COMPETENCE_TYPE_TECHNOLOGY,
  } from '@/api/models/CompetenceType';

  const emit = defineEmits(['update']);

  const props = defineProps({
    index: {
      type: Number,
      required: true,
    },
    competenceSet: Object,
    competenceOptions: {
      type: Array,
      default: () => [],
    },
    apiErrors: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
  });

  const model = reactive({
    id: null,
    competenceSubject: null,
    competenceTechnology: null,
    competenceSkill: null,
  });

  const errors = new ErrorsHandler({
    competenceSubject: '',
    competenceTechnology: '',
    competenceSkill: '',
  });

  onMounted(() => {
    fillModel();
  });

  watch(
    () => props.competenceSet,
    () => {
      fillModel();
    },
    { deep: true }
  );

  watch(
    () => props.apiErrors,
    () => {
      if (props.apiErrors && props.apiErrors['errors'])
        errors.handleApiErrors(props.apiErrors);
    }
  );

  const fillModel = () => {
    model.id = props.competenceSet.id;
    model.status = props.competenceSet.status;
    model.competenceSubject = props.competenceSet.competenceSubject;
    model.competenceTechnology = props.competenceSet.competenceTechnology;
    model.competenceSkill = props.competenceSet.competenceSkill;
  };

  const handleUpdate = (competence) => {
    switch (competence?.type) {
      case COMPETENCE_TYPE_SUBJECT:
        model.competenceSubject = competence;
        break;
      case COMPETENCE_TYPE_TECHNOLOGY:
        model.competenceTechnology = competence;
        break;
      case COMPETENCE_TYPE_SKILL:
        model.competenceSkill = competence;
        break;
    }

    emit('update', { index: props.index, competenceSet: model });
  };

  const handleDelete = (competenceType) => {
    switch (competenceType) {
      case COMPETENCE_TYPE_SUBJECT:
        model.competenceSubject = null;
        break;
      case COMPETENCE_TYPE_TECHNOLOGY:
        model.competenceTechnology = null;
        break;
      case COMPETENCE_TYPE_SKILL:
        model.competenceSkill = null;
        break;
    }

    emit('update', { index: props.index, competenceSet: model });
  };
</script>

<style lang="scss" scoped>
  @use "@/assets/styles/_colors.scss" as *;

  .field__label {
    color: $color-text-secondary-1;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 8px;
  }
</style>
